import { render, staticRenderFns } from "./UserManagementCard.vue?vue&type=template&id=7b17fb35&scoped=true"
import script from "./UserManagementCard.vue?vue&type=script&lang=js"
export * from "./UserManagementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17fb35",
  null
  
)

export default component.exports